import RootAccounts from './RootAccounts';

export default RootAccounts;
